import React from 'react';
import { ValueType } from 'react-select';
import { Box, Link } from '@99designs/emu';
import { breakpoints } from '@99designs/emu/settings';
import { FormattedMessage } from '@99designs/frontend-components/i18n';
import { SearchableSelect } from '../../components/Form/SearchableSelect';
import { useOnboarderNav } from '../../components/Onboarder/useOnboarderNav';
import { Answer } from '../../components/Step/Answer';
import { getIndustryLabel, industries } from '../../utils/industries';
import type { Option } from '../../components/Form/SearchableSelect';
import type { StepComponentProps, StepHeadingProps } from '../../components/Onboarder/Config';
import type { Data } from '../config';

export function IndustryStepInput({ data, onChange }: StepComponentProps<Data>) {
    const onboarderNav = useOnboarderNav();
    const industry = industries().find((i) => i.value === data.industry);

    return (
        <>
            <SearchableSelect
                options={industries()}
                value={industry}
                label="industry-select"
                placeholderText={getPlaceholderText()}
                onChange={(value: ValueType<Option, boolean>) => {
                    const selectedOptionValue = value ? (value as Option).value : undefined;
                    onChange({
                        ...data,
                        industry: selectedOptionValue,
                    });
                }}
            />
            <Box marginTop="0.5bu" display="flex" justifyContent="flex-end">
                <Link
                    aria-label={__('Skip this step')}
                    onClick={() => {
                        const clearedData = {
                            ...data,
                            industry: undefined,
                        };
                        onChange(clearedData);
                        onboarderNav
                            .currentStep()
                            .trackCompleted(clearedData, onboarderNav.currentStepIndex() + 1);
                        onboarderNav.goToNextStep();
                    }}
                >
                    {__('Skip this step')}
                </Link>
            </Box>
        </>
    );
}

const getPlaceholderText = () => {
    if (window.innerWidth < breakpoints['medium'][0]) {
        return __('Select industry');
    }
    return __('Search for or select an industry');
};

export const questionCopy = () => __('For a website within the {answer} industry');

export function IndustryStepHeading({ data }: StepHeadingProps<Data>) {
    const answer = getIndustryLabel(data.industry);

    return (
        <span>
            <FormattedMessage
                message={questionCopy()}
                values={{ answer: <Answer text={answer} /> }}
            />
        </span>
    );
}
